import React from 'react'
import { Solicitudes } from './Solicitudes.module';
import { Usuarios } from './Usuarios.module';
import { Administrativos } from './Administrativos.module';

export const MantenedorContainer = ({ PageSelected,datosPrecargados }) => {
    switch (PageSelected) {
        case "SOLICITUDES":
            return <Solicitudes />;

        case "USUARIOS":
            return <Usuarios />;

        case "ADMINISTRATIVOS":
            return <Administrativos datosPrecargados={datosPrecargados} />;

        default:
            return <div>Seleccione una opción</div>;
    }


}
